export default __webpack_public_path__ + "static/media/SF.9415be21.png";